import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarCartMHComponent } from './sidebar-cart.component';
import { CartPreviewModule } from '../../cart/preview/cart-preview.module';


@NgModule({
  declarations: [
    SidebarCartMHComponent,
  ],
  imports: [
    CommonModule,

    CartPreviewModule,
  ],
  exports: [
    SidebarCartMHComponent,
  ]
})
export class SidebarCartModule { }
